import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 488,
	height: 328,
	viewBox: "0 0 488 328",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M477.401 9.76325C464.385 -3.25442 443.278 -3.25442 430.261 9.76325L188.758 251.267C175.74 264.284 154.634 264.284 141.617 251.267L56.9037 166.554C43.886 153.537 22.7807 153.537 9.763 166.554C-3.25433 179.57 -3.25433 200.677 9.763 213.694L94.6593 298.367C133.724 337.33 196.965 337.29 235.981 298.28L477.401 56.9036C490.418 43.8862 490.418 22.7806 477.401 9.76325Z" })
});
export default SvgCheckmark;
